import AccessPoint from '@kalvi-education/kalvium-sdk/src/constants/AccessPoint.js'
import axios from 'axios'

const submitTicket = async (formData, token) => {
    try {
        const url = new URL(AccessPoint().tickets)

        const response = await axios.post(url.toString(), formData, {
            headers: {
                contentType: 'options/json',
                Authorization: `Bearer ${token}`,
            },
        })

        if (response.status === 200 || response.status === 201) {
            return { success: true, data: response.data }
        } else {
            return { success: false }
        }
    } catch (error) {
        console.error('Error submitting ticket:', error)
        return { success: false, error }
    }
}

export { submitTicket }
